module.exports = __webpack_public_path__ + "static/media/ic_help.eb53a93e.svg";